import { render, staticRenderFns } from "./CalendarCard.vue?vue&type=template&id=5cc6d508&"
import script from "./CalendarCard.vue?vue&type=script&lang=js&"
export * from "./CalendarCard.vue?vue&type=script&lang=js&"
import style0 from "./CalendarCard.vue?vue&type=style&index=0&id=5cc6d508&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports